import GcHeading from '@garmin/components-global/src/components/GcHeading/index.vue';
import GcCopy from '@garmin/components-global/src/components/GcCopy/index.vue';

export default {
  name: 'PcCopy',
  data() {
    return {
      className: 'app__product__copy',
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    titleHeadingSize: {
      type: String,
      default: 'h2',
    },
    titleAlign: {
      type: String,
      default: 'center',
    },
    description: {
      type: String,
      default: '',
    },
    descriptionAlign: {
      type: String,
      default: 'left',
    },
    descriptionSize: {
      type: String,
      default: 'primary',
    },
    theme: {
      type: String,
      default: 'light',
    },
  },
  computed: {
    themeClassName() {
      return `${this.className}--${this.theme}`;
    },
    titleClassName() {
      return `${this.className}__title`;
    },
    descriptionClassName() {
      return `${this.className}__description`;
    },
  },
  components: {
    GcHeading,
    GcCopy,
  },
};
